/**
 * Could one day be published as an external module?
 */
export default function VueEvents(Vue) {
  if (VueEvents.installed) {
    // Immediately return if this method has previously executed
    return;
  } else {
    VueEvents.installed = true;
  }

  Vue.mixin({
    beforeCreate() {
      if (this.$options.events) {
        for (const key in this.$options.events) {
          if (this.$options.events.hasOwnProperty(key) && typeof this.$options.events[key] === 'function') {
            this.$root.$on(key, this.$options.events[key].bind(this));
          }
        }
      }
    },
    beforeDestroy() {
      if (this.$options.events) {
        for (const key in this.$options.events) {
          if (this.$options.events.hasOwnProperty(key) && typeof this.$options.events[key] === 'function') {
            this.$root.$off(key, this.$options.events[key].bind(this));
          }
        }
      }
    },
  });
};



// WEBPACK FOOTER //
// ./src/plugins/vue-events.js